import * as React from 'react';

function useIframeAriaRefFix(ref: React.RefObject<HTMLElement | null>) {
  React.useEffect(() => {
    if (!window.chekinCustomDocument) {
      return;
    }

    const id = ref.current?.id;
    if (!id) {
      return;
    }

    const mirror = document.createElement('span');
    mirror.id = id;
    mirror.style.display = 'none';
    document.body.appendChild(mirror);

    return () => {
      mirror.remove();
    };
  }, [ref]);
}

export {useIframeAriaRefFix};
